import * as React from "react";
import { ApiMe } from "../misc/api/AccountServer/AccountApi";

export const useAccountKeepAlive = () => {
    const [isActive, setIsActive] = React.useState(false);

    React.useEffect(() => {
        let interval = null;
        if (!isActive) {
            ApiMe();

            interval = setInterval(() => {
                ApiMe()
                    .then(response => {
                        if (response.status === 401)
                            clearInterval(interval);
                    });
            }, 600000);
            setIsActive(true);
        }
        return () => clearInterval(interval);
    }, []);

    return { isActive };
};
